function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { CerbosOrgActions, CerbosPeopleKind } from '@shared/cerbos-types';
import { buildAbacPrincipal, buildPeopleAttributes } from '../abac';
import { getDecision } from '../decision';
const checkAction = async (organization, user, action)=>{
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosPeopleKind,
            id: organization.id,
            attributes: buildPeopleAttributes(organization, {
                oldData: {},
                newData: {},
                organization: organization
            })
        },
        actions: [
            action
        ]
    });
    return decision.isAllowed(action);
};
const checkActions = async (organization, user, peopleLimitExceeded, actions)=>{
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosPeopleKind,
            id: organization.id,
            attributes: buildPeopleAttributes(organization, {
                oldData: {
                    peopleLimitExceeded
                },
                newData: {
                    peopleLimitExceeded
                },
                organization: organization
            })
        },
        actions
    });
    return actions.map((action)=>decision.isAllowed(action));
};
export const getCanManageAll = async (organization, user)=>{
    return checkAction(organization, user, CerbosOrgActions.CAN_MANAGE_ALL);
};
export const getCanManageMembers = async (organization, user)=>{
    return checkAction(organization, user, CerbosOrgActions.CAN_MANAGE_PEOPLE);
};
export const getCanManageOwner = async (organization, user)=>{
    return checkAction(organization, user, CerbosOrgActions.CAN_MANAGE_OWNER);
};
export const canMangeConfigKey = [
    'canManage',
    CerbosOrgActions.CAN_MANAGE_ALL,
    CerbosOrgActions.CAN_MANAGE_PEOPLE,
    CerbosOrgActions.CAN_MANAGE_OWNER
].join('/');
export const getCanManageConfig = async (organization, user, peopleLimitExceeded)=>{
    const [manageAll, managePeople, manageOwner] = await checkActions(organization, user, peopleLimitExceeded, [
        CerbosOrgActions.CAN_MANAGE_ALL,
        CerbosOrgActions.CAN_MANAGE_PEOPLE,
        CerbosOrgActions.CAN_MANAGE_OWNER
    ]);
    return {
        manageAll: manageAll !== null && manageAll !== void 0 ? manageAll : false,
        managePeople: managePeople !== null && managePeople !== void 0 ? managePeople : false,
        manageOwner: manageOwner !== null && manageOwner !== void 0 ? manageOwner : false
    };
};
export const getAllowedActions = async (organization, user, member, peopleLimitExceeded)=>{
    const action = CerbosOrgActions.INVITE_PEOPLE;
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosPeopleKind,
            id: organization.id,
            attributes: buildPeopleAttributes(organization, {
                oldData: {
                    peopleLimitExceeded
                },
                newData: _object_spread_props(_object_spread({}, member), {
                    peopleLimitExceeded
                }),
                organization: organization
            })
        },
        actions: [
            action
        ]
    });
    return decision.isAllowed(action);
};
export const getCanInviteMember = async (organization, user, member)=>{
    const action = CerbosOrgActions.CAN_INVITE_PEOPLE;
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosPeopleKind,
            id: organization.id,
            attributes: buildPeopleAttributes(organization, {
                oldData: {},
                newData: member,
                organization: organization
            })
        },
        actions: [
            action
        ]
    });
    return decision.isAllowed(action);
};
export const getCanUpdateMember = async (organization, user, member, oldMember)=>{
    const action = CerbosOrgActions.CAN_UPDATE_PEOPLE;
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosPeopleKind,
            id: organization.id,
            attributes: buildPeopleAttributes(organization, {
                targetUserId: oldMember.id,
                oldData: oldMember,
                newData: member,
                organization: organization
            })
        },
        actions: [
            action
        ]
    });
    return decision.isAllowed(action);
};
export const getCanDeleteMember = async (organization, user, member)=>{
    const action = CerbosOrgActions.DELETE_PEOPLE;
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosPeopleKind,
            id: organization.id,
            attributes: buildPeopleAttributes(organization, {
                targetUserId: member.id,
                oldData: member,
                newData: {},
                organization: organization
            })
        },
        actions: [
            action
        ]
    });
    return decision.isAllowed(action);
};
